module.exports = __webpack_public_path__ + "static/media/hardfloor.68b56e82.jpg";